/**
 * Created By Elia Rohana on 12/2/18
 */

import { createFeatureSelector, MemoizedSelector } from '@ngrx/store';
import { State } from '../state';

export const selectBpmnModelerState: MemoizedSelector<
    object,
    State
    > = createFeatureSelector<State>('BpmnModeler');
